
import { Component, Vue } from 'vue-property-decorator'
import InputTextBase from '@/components/atoms/InputTextBase.vue'

/**
 * 設問解答の入力欄
 */
@Component({
  components: {
    InputTextBase,
  },
})
export default class InputAnswerText extends Vue {
  /**
   * 入力時のイベント
   *
   * @param value 入力値
   */
  private inputEvent(value: string): void {
    this.$emit('input', value)
  }
}
